module.exports = __webpack_public_path__ + "static/media/progress.40291683.svg";